import { useState } from "react";
import { toast } from "sonner";

export default function Contact() {
    const [form, setForm] = useState({ name: "", email: "", message: "" });
    const submit = (e) => {
        e.preventDefault();
        toast.success("Message sent. We'll be in touch shortly.");
        setForm({ name: "", email: "", message: "" });
    };
    return (
        <main data-testid="contact-page" className="bg-black min-h-screen pt-32 pb-24">
            <div className="container-luxury grid grid-cols-1 md:grid-cols-2 gap-16">
                <div>
                    <div className="overline mb-6">Contact</div>
                    <h1 className="font-serif text-5xl sm:text-6xl tracking-tight leading-[0.95] mb-8">Begin a conversation.</h1>
                    <p className="text-white/70 leading-relaxed mb-8 max-w-md">
                        Whether you represent an architectural firm, a development, or a private client — we'll route your inquiry to the right specialist within 24 hours.
                    </p>
                    <div className="space-y-3 text-sm text-white/70">
                        <div><span className="overline mr-3">Email</span><span className="text-gold">hello@tilesphere.com</span></div>
                        <div><span className="overline mr-3">Phone</span><span>+63 (02) 8888-0000</span></div>
                    </div>
                </div>
                <form onSubmit={submit} data-testid="contact-form" className="space-y-4">
                    <input required value={form.name} onChange={(e)=>setForm(f=>({...f,name:e.target.value}))} placeholder="Your name" data-testid="contact-name" className="w-full bg-[#0a0a0a] border border-white/15 px-4 py-4 focus:border-gold focus:outline-none text-white" />
                    <input required type="email" value={form.email} onChange={(e)=>setForm(f=>({...f,email:e.target.value}))} placeholder="Email" data-testid="contact-email" className="w-full bg-[#0a0a0a] border border-white/15 px-4 py-4 focus:border-gold focus:outline-none text-white" />
                    <textarea required rows={6} value={form.message} onChange={(e)=>setForm(f=>({...f,message:e.target.value}))} placeholder="Tell us about your project…" data-testid="contact-message" className="w-full bg-[#0a0a0a] border border-white/15 px-4 py-4 focus:border-gold focus:outline-none text-white resize-none" />
                    <button type="submit" data-testid="contact-submit" className="btn-gold w-full">Send Message</button>
                </form>
            </div>
        </main>
    );
}
